export default "__VITE_ASSET__jgxJju_u__"